export default function Media({
  src,
  alt = "",
  className = "",
  contain = false,
  eager = false,
  type,
  width,
  height,
  allow,
  allowFullScreen = true,
  autoPlay,
  controls,
  loop,
  muted,
  poster,
  referrerPolicy,
}) {
  if (!src) {
    return null;
  }

  const classes = [
    "media-frame",
    contain ? "media-frame--contain" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
  const mediaStyle =
    width && height ? { aspectRatio: `${width} / ${height}` } : undefined;

  if (type === "iframe") {
    return (
      <div className={`${classes} media-frame--embed`} style={mediaStyle}>
        <iframe
          allow={allow || "autoplay; fullscreen; picture-in-picture"}
          allowFullScreen={allowFullScreen}
          loading="lazy"
          referrerPolicy={referrerPolicy}
          src={src}
          title={alt || "Embedded media"}
        />
      </div>
    );
  }

  if (type === "video" || /\.(mp4|webm)(?:$|\?)/i.test(src)) {
    return (
      <div className={classes} style={mediaStyle}>
        <video
          autoPlay={autoPlay}
          controls={controls ?? !autoPlay}
          loop={loop}
          muted={muted}
          playsInline
          poster={poster}
        >
          <source src={src} />
        </video>
      </div>
    );
  }

  return (
    <div className={classes} style={mediaStyle}>
      <img
        alt={alt}
        decoding="async"
        fetchPriority={eager ? "high" : undefined}
        loading={eager ? "eager" : "lazy"}
        src={src}
      />
    </div>
  );
}
